import React from 'react';
import styled from 'styled-components';
import { ContainerScope, resolve } from '../../Container';
import { CommandInterpreter } from '../extensibility/CommandInterpreter';
import { CommandScript } from '../extensibility/CommandScript';
import { PopoutWidget } from '../workspace/widgets/WidgetInterface';
import { Box, Colors, HeroIcons } from './../../../ui';

export class CommandScriptWidget extends React.Component<{ widget: PopoutWidget }> {

    public static contextType = ContainerScope;

    @resolve(CommandInterpreter) private interpreter!: CommandInterpreter;

    private updateId: any = null;

    public state = {
        source: '',
        script: null as CommandScript | null,
        verified: false,
        error: null as string | null,
    };

    public render() {
        const { source, verified, error } = this.state;
        return <Box flex width="50" padding="0.5" style={{ flexDirection: 'column' }}>
            <Input rows={15} value={source} onChange={this.inputDidChange} />
            <Status>
                {verified && <Success>Valid <HeroIcons.Check size={24} /></Success>}
                {error && <Error>{error}</Error>}
            </Status>
        </Box>;
    }

    public componentDidMount() {
        this.setState({ source: this.props.widget.value }, this.updateFromSource);
    }

    private inputDidChange = (e: any) => {
        this.setState({ source: e.target.value });
        this.resetAllButSource();
        this.scheduleUpdate();
    };

    private scheduleUpdate() {
        if (this.updateId) clearTimeout(this.updateId);
        this.updateId = setTimeout(this.updateFromSource, 750);
    }

    private updateFromSource = () => {
        const { interpreter } = this;
        if (this.state.source) {
            const script = CommandScript.parse(this.state.source);
            const [verified, error] = interpreter.verify(script);
            this.setState({ script, verified, error });
            if (verified) {
                this.props.widget.update({ value: this.state.source });
            }
        }
        else {
            this.resetAllButSource();
        }
    };

    private resetAllButSource = () => {
        this.setState({ script: null, verified: false, error: null });
    };
}

const Input = styled.textarea`
    resize: none;
    padding: 0.5rem;
    font-family: 'Fira Mono';
    border-radius: 4px;
    background: whitesmoke;
`;

const Status = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-height: 1.5rem;
    margin-top: 0.4rem;
    font-family: Inter;
    font-weight: 450;

    svg {
        margin-left: .5rem;
    }
`;

const Success = styled.div`
    display: contents;
    color: ${Colors.positive};
`;

const Error = styled.div`
    display: contents;
    color: ${Colors.negative};
`;
